import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/login'
import Gateway from '@/components/gateway'
import Scene from '@/components/scene'
import Settings from '@/components/settings'
import Activity from '@/components/activity'
import Introduce from '@/components/introduce'
import Join from '@/components/join'
import Client from '@/components/client'
import Privacy from '@/components/privacy'
import Terms from '@/components/terms'
import Authorize from '@/components/authorize'
import Device from '@/components/device'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'app_name',
    component: Introduce
  }, {
    path: '/login',
    name: 'menu.login',
    component: Login
  }, {
    path: '/terms',
    name: 'menu.terms',
    component: Terms
  }, {
    path: '/privacy',
    name: 'menu.privacy',
    component: Privacy
  }, {
    path: '/authorize',
    name: 'menu.authorization',
    component: Authorize
  }, {
    path: '/gateway',
    name: 'menu.my_gateway',
    component: Gateway,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/device',
    name: 'menu.my_device',
    component: Device,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/scene',
    name: 'menu.my_scene',
    component: Scene,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/settings',
    name: 'menu.settings',
    component: Settings,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/activity',
    name: 'menu.my_activity',
    component: Activity,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/join/:clientId',
    name: 'menu.join',
    component: Join
  }, {
    path: '/client',
    name: 'menu.my_client',
    component: Client,
    meta: {
      requiresAuth: true
    }
  }],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js